import "./vison.css";

const Vison = () =>{

    return(
        <div className="spoon-shape">
            {/* left content div */}
            <div className="content-div">
                <span className="vision-1">OUR VISION</span>
                <span className="vision-2">Empowering Businesses <br className="next-line" /> <span className="vision-text-2">Through Innovative Identity Verification</span></span>
                <span className="vision-3">We believe that businesses deserve access to cutting-edge tools that simplify identity verification and enhance customer satisfaction. Our vision is to deliver innovative solutions that address the unique challenges faced by businesses today, ensuring a seamless and secure experience for both customers and organizations.</span>
            </div>

            {/* right image div */}
            <div className="image-div">
                <img src="https://befisc-website-assets.s3.ap-south-1.amazonaws.com/assets/Image.svg
" className="image-size" />
            </div>

        </div>
    )
}

export default Vison;